import React from "react";

function Loading() {
    return (
        <div
            className="spinner-border"
            role="status"
            style={{
                height: 45,
                width: 45,
                color:"#656565"
            }}
        >
            <span className="sr-only">Loading...</span>
        </div>
    );
}

export default Loading;
